/**
 * Geolocation Button
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'geolocation-button';
const log = debug(MODULE_NAME);

//
// Dependencies
import * as geolocation from '../../services/geolocation';
import {GEOLOCATION_BUTTON_DATA_ATTRIBUTE, GEOLOCATION_BUTTON_SELECTOR, SEARCH_FIELD_NAME, LAT_FIELD_NAME, LNG_FIELD_NAME, GPS_FIELD_NAME} from './config';

//
// Private Functions
/**
 * Builds a selector for named inputs.
 * @param name
 * @returns {string}
 */
function namedInputSelector(name) {
	return `input[name="${name}"]`;
}

//noinspection FunctionWithMoreThanThreeNegationsJS
/**
 *
 * @param {HTMLFormElement} form
 * @param {{search: HTMLInputElement, lat: HTMLInputElement, lng: HTMLInputElement, gps: HTMLInputElement}=} existing
 * @returns {{search: HTMLInputElement, lat: HTMLInputElement, lng: HTMLInputElement, gps: HTMLInputElement}}
 */
function getLocationFieldElements(form, existing) {
	const $form = $(form);

	if (!existing) {
		existing = {};
	}

	if (!existing.search) {
		existing.search = /** @type {HTMLInputElement} */ $form.find(`${namedInputSelector(SEARCH_FIELD_NAME)}`).get(0);
	}

	if (!existing.lat) {
		existing.lat = /** @type {HTMLInputElement} */ $form.find(`${namedInputSelector(LAT_FIELD_NAME)}`).get(0);
	}

	if (!existing.lng) {
		existing.lng = /** @type {HTMLInputElement} */ $form.find(`${namedInputSelector(LNG_FIELD_NAME)}`).get(0);
	}

	if (!existing.gps) {
		existing.gps = /** @type {HTMLInputElement} */ $form.find(`${namedInputSelector(GPS_FIELD_NAME)}`).get(0);
	}

	log('getLocationFieldElements result:', existing);
	return existing;
}

/**
 * Initialises the Geolocation Button
 * @param button
 */
function initialiseGeolocationButton(button) {
	log('initialiseGeolocationButton:', button);

	/** @type {{search: HTMLInputElement=, lat: HTMLInputElement=, lng: HTMLInputElement=, gps: HTMLInputElement=}} */
	let formElements;
	const targetFieldId = button.getAttribute(GEOLOCATION_BUTTON_DATA_ATTRIBUTE);
	const $button = $(button);

	// No point continuing if we have no target to bind to.
	if (!targetFieldId || targetFieldId === '') {
		return;
	}

	$button.on('click.geolocation', (event) => {
		event.preventDefault();

		// Parse the form on first click only
		// This is dodgy, as it assumes the click will happen after `location-autocomplete` has already run; which
		// to be fair, is extremely unlikely that it ever wouldn't.
		if (!formElements) {
			// For performance reasons, we already have the ID of the target field so let's just get that up front
			formElements = {
				search: /** @type {HTMLInputElement} */ document.getElementById(targetFieldId)
			};

			formElements = getLocationFieldElements(formElements.search.form, formElements);
		}

		geolocation.getCurrentLocation()
			.then((latLng) => {
				// Get the address at their current position
				return Promise.all([latLng, geolocation.geocodeLatLng(latLng)]);
			})
			.then((results) => {
				/** @type {{lat: Number, lng: Number}} */
				const latLng = results[0];
				const addressResult = results[1]; // Google Maps address result object

				log('Location latLng:', latLng);
				log('Location addressResult:', addressResult);

				// Update lat/lng fields
				formElements.lat.value = latLng.lat.toString();
				formElements.lng.value = latLng.lng.toString();

				// Update input field location
				formElements.search.value = addressResult.formatted_address;
				//noinspection JSValidateTypes
				formElements.gps.value = 1;

				// Trigger change
				$(formElements.search).trigger('change');
			})
			.catch((e) => {
				log(e);

				// PositionError
				if (e.code) {
					$button.attr('disabled', '');
					$button.attr('title', 'Location currently unavailable');
					$button.off('.geolocation');
				}
			});

		$button.blur();
	});
}

//
// Export
export function exec () {
	log('Running...');	
	const $buttons = $(GEOLOCATION_BUTTON_SELECTOR);

	if ($buttons.length) {
		$buttons.each((index, button) => {
			initialiseGeolocationButton(button);
		});
	}
}

export {exec as default};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/geolocation-button.js